module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightsnow-864c37f14c646f0ccd8b744192493ebe.png";